import {
  Alert,
  alpha,
  Box,
  Button,
  Card,
  FormControl,
  FormControlLabel,
  Modal,
  Radio,
  RadioGroup,
  Snackbar,
  Stack,
  Switch,
  Tab,
  Tabs,
  Typography,
  useTheme,
  Fade,
  Collapse,
  TextField,
  InputAdornment,
  Checkbox,
  FormGroup,
} from "@mui/material";

import useStyles from "./styles";
import { useEffect, useState } from "react";
import api from "../../../services/api";

import { Check, CloseOutlined, BoltOutlined } from "@mui/icons-material";
import AlertModal from "../../alertModal";
import { useMapa } from "../../../contexts/mapaContext";

export default function ConfiguracaoMapModal({ open, setOpen = () => {} }) {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [tabValue, setTabValue] = useState(0);
  const [openAlertModal, setOpenAlertModal] = useState(null);
  const [checkChanges, setCheckChanges] = useState(false);

  // página de alertas
  const [filterInterface, setFilterInterface] = useState(false);
  const [filterItems, setFilterItems] = useState(false);
  const [filterSeverity, setFilterSeverity] = useState(false);
  const [severityLevels, setSeverityLevels] = useState({
    5: true,
    4: false,
    3: false,
    2: false,
  });

  const listTabs = [{ label: "Alertas", icon: <BoltOutlined />, value: 0 }];
  const {
    configurationMap,
    setConfigurationMap,
    setSnackbar,
    updateDataElementSocket,
    mapId,
  } = useMapa();

  useEffect(() => {
    if (open) {
      setTabValue(0);
      setFilterInterface(
        configurationMap?.configuracoes?.alerts?.filterInterface?.enable ||
          false
      );
      setFilterItems(
        configurationMap?.configuracoes?.alerts?.filterItens?.enable || false
      );
      setFilterSeverity(
        configurationMap?.configuracoes?.alerts?.filterSeverity?.enable || false
      );
      setSeverityLevels(
        configurationMap?.configuracoes?.alerts?.filterSeverity?.severity || {
          5: true,
          4: false,
          3: false,
          2: false,
        }
      );
      setCheckChanges(false);
    }
  }, [open, configurationMap]);

  const handleClose = () => {
    setTabValue(0);
    setFilterInterface(false);
    setFilterItems(false);
    setFilterSeverity(false);
    setCheckChanges(false);
    setOpen(false);
    setSeverityLevels({ 5: false, 4: false, 3: false, 2: false });
  };

  async function handleApiUpdateConfigMap() {
    try {
      const response = await api.put("/easyMaps/map/config/update", {
        id: configurationMap?.id,
        data: {
          ...configurationMap,
          mapId,
          configuracoes: {
            ...configurationMap?.configuracoes,
            alerts: {
              filterInterface: { enable: filterInterface },
              filterItens: { enable: filterItems },
              filterSeverity: {
                enable: filterSeverity,
                severity: severityLevels,
              },
            },
          },
        },
      });

      if (response.data.status === "Error") {
        setSnackbar({
          children:
            "Error: Não foi possível salvar as mudanças as configurações",
          severity: "error",
        });
      } else {
        if (response.data) {
          setConfigurationMap(response.data);
          handleClose();
          updateDataElementSocket();
          setSnackbar({
            children: "Configurações salvas com sucesso!",
            severity: "success",
          });
        }
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  function handleSeverityChange(level) {
    const newLevels = { ...severityLevels, [level]: !severityLevels[level] };
    setSeverityLevels(newLevels);
    setCheckChanges(true);
  }

  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Card sx={styles.container}>
          <Stack sx={styles.containerTab}>
            <Typography sx={styles.pageTitle}>Configurações do mapa</Typography>
            <Tabs
              orientation="vertical"
              scrollButtons={true}
              value={tabValue}
              onChange={(event, newValue) => {
                setTabValue(newValue);
              }}
              sx={styles.tabs}
            >
              {listTabs.map((tab, index) => (
                <Tab
                  key={index + "tab"}
                  label={tab.label}
                  iconPosition="start"
                  icon={tab?.icon}
                  value={tab?.value}
                />
              ))}
            </Tabs>
          </Stack>
          <Stack sx={styles.containerData}>
            <Typography sx={{ ...styles.pageTitle, ...styles.titlePage }}>
              {listTabs[tabValue]?.label || ""}
            </Typography>

            <Stack
              gap={1.5}
              sx={{ maxHeight: "80%", overflow: "auto", pr: "5px" }}
            >
              {tabValue ==
                listTabs.find((a) => a.label == "Alertas")?.value && (
                <>
                  <Box sx={styles.boxOP}>
                    <Switch
                      checked={filterInterface}
                      onChange={() => {
                        setFilterInterface(!filterInterface);
                        setCheckChanges(true);
                      }}
                      sx={styles.switch}
                    />
                    <Stack direction="column">
                      <Typography sx={styles.text}>
                        {" "}
                        Filtro por Interface do host
                      </Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Mostra apenas alertas relacionados às interfaces
                        vinculadas aos hosts exibidos no mapa.
                      </Typography>
                    </Stack>
                    <Stack sx={{ p: 1 }}>
                      <Collapse
                        in={filterInterface}
                        timeout={300}
                        unmountOnExit
                      >
                        <FormControl>
                          <RadioGroup
                            aria-labelledby="demo-radio-buttons-group-label"
                            name="radio-buttons-group"
                            value={filterItems ? "true" : "false"}
                            onChange={(e) => {
                              setFilterItems(e.target.value === "true");
                              setCheckChanges(true);
                            }}
                          >
                            <FormControlLabel
                              value={"false"}
                              control={<Radio />}
                              label={
                                <Typography sx={styles.textSize}>
                                  Exibir alertas de todos os itens das
                                  interfaces selecionadas e itens explicitamente
                                  adicionados
                                </Typography>
                              }
                            />
                            <FormControlLabel
                              value={"true"}
                              control={<Radio />}
                              label={
                                <Typography sx={styles.textSize}>
                                  Exibir alertas apenas dos itens explicitamente
                                  adicionados
                                </Typography>
                              }
                            />
                          </RadioGroup>
                        </FormControl>
                      </Collapse>
                    </Stack>
                  </Box>

                  <Box sx={styles.boxOP}>
                    <Switch
                      checked={filterSeverity}
                      onChange={() => {
                        setFilterSeverity(!filterSeverity);
                        setCheckChanges(true);
                      }}
                      sx={styles.switch}
                    />
                    <Stack direction="column">
                      <Typography sx={styles.text}>
                        {" "}
                        Filtro por Severidade
                      </Typography>

                      <Typography sx={{ ...styles.textFine }}>
                        Escolha os níveis de severidade que deseja visualizar
                        nos alertas
                      </Typography>
                    </Stack>
                    <Stack sx={{ p: 1 }}>
                      <Collapse in={filterSeverity} timeout={300} unmountOnExit>
                        {/* <TextField
                          sx={styles.textField}
                          type="number"
                          //value={linkLight}
                          //onChange={(e) => {}}
                          size="small"
                          slotProps={{
                            input: {
                              startAdornment: (
                                <InputAdornment position="start">
                                  <Typography sx={styles.textAdorment}>
                                    Nivel de Severidade
                                  </Typography>
                                </InputAdornment>
                              ),
                            },
                          }}
                        /> */}
                        <FormGroup
                          sx={{
                            display: "flex",
                            flexDirection: "row-reverse",
                            justifyContent: "flex-end",
                          }}
                        >
                          <FormControlLabel
                            control={
                              <Checkbox
                                disabled
                                defaultChecked
                                //checked={severityLevels[5]}
                                //onChange={() => handleSeverityChange(5)}
                              />
                            }
                            label="Desatre"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={severityLevels[4]}
                                onChange={() => handleSeverityChange(4)}
                              />
                            }
                            label="Alto Impacto"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={severityLevels[3]}
                                onChange={() => handleSeverityChange(3)}
                              />
                            }
                            label="Moderado"
                          />
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={severityLevels[2]}
                                onChange={() => handleSeverityChange(2)}
                              />
                            }
                            label="Alerta"
                          />
                        </FormGroup>
                      </Collapse>
                    </Stack>
                    <Collapse in={filterSeverity} timeout={300} unmountOnExit>
                      <Alert severity="info" sx={{ mt: 1 }}>
                        <Typography sx={styles.textFine}>
                          O filtro de severidade sobrepõe outros filtros. Se
                          estiver ativo, apenas os alertas com a severidade
                          selecionada serão exibidos.
                        </Typography>
                      </Alert>
                    </Collapse>
                  </Box>
                </>
              )}
            </Stack>
            <Stack
              direction={"row"}
              sx={{ bottom: "10px", right: "10px", position: "absolute" }}
            >
              <Button
                onClick={() => {
                  if (!checkChanges) {
                    handleClose();
                    return;
                  }
                  setOpenAlertModal({
                    open: true,
                    callback: handleClose,
                    severity: "error",
                    severity: "warning",
                    text: "As alterações feitas não foram salvas. Se prosseguir com a operação as mudanças serão perdidas.",
                  });
                }}
                sx={styles.buttomEnd}
                startIcon={<CloseOutlined />}
              >
                Cancelar
              </Button>
              <Button
                onClick={handleApiUpdateConfigMap}
                sx={styles.buttomEnd}
                color="white"
                startIcon={<Check />}
                disabled={!checkChanges}
              >
                Salvar
              </Button>
            </Stack>
          </Stack>
        </Card>
      </Modal>

      <AlertModal
        openModal={openAlertModal?.open ?? false}
        setOpenModal={(data) => setOpenAlertModal({ open: data })}
        buttonText={openAlertModal?.buttonText}
        buttonCancelText={openAlertModal?.buttonCancelText}
        confirmar={false}
        handleButton={() => {
          setOpenAlertModal({ open: false });
          if (openAlertModal.callback) {
            openAlertModal.callback(...(openAlertModal?.params || []));
            return;
          }
        }}
        severity={openAlertModal?.severity}
        singleButton={false}
        textContent={openAlertModal?.text}
      />
    </>
  );
}
